import type { Option, NullableOption } from './types';

export const getOptionsWithoutSelected = (
	selectOptions: Option[],
	selectedValue: NullableOption | undefined,
) =>
	selectOptions.filter(
		(option) => option.label !== selectedValue?.label && option.value !== selectedValue?.value,
	);
